/* ==========================================================
   ENJOYTHEMUSIC — PHASE 1
   Header scroll behavior
========================================================== */

document.addEventListener('DOMContentLoaded', () => {

  const header = document.querySelector('.header-wrapper');

  if (!header) return;

  let ticking = false;


  function updateHeader() {

    if (window.scrollY > 40) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }

    ticking = false;
  }


  function onScroll() {

    if (!ticking) {

      window.requestAnimationFrame(() => {
        updateHeader();
      });

      ticking = true;
    }
  }


  updateHeader();

  window.addEventListener(
    'scroll',
    onScroll,
    { passive: true }
  );

});
document.addEventListener('DOMContentLoaded', function () {

  const cursor = document.getElementById('etm-cursor');
  const ring = document.getElementById('etm-cursor-ring');
  const dot = document.getElementById('etm-cursor-dot');

  if (!cursor || !ring || !dot) return;


  /* ==========================================================
     MAGNETIC + VELOCITY CURSOR
     RING + DOT
  ========================================================== */

  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight / 2;

  let currentX = mouseX;
  let currentY = mouseY;

  let previousMouseX = mouseX;
  let previousMouseY = mouseY;

  let velocityX = 0;
  let velocityY = 0;

  /* Ring magnetic offset */
  let ringOffsetX = 0;
  let ringOffsetY = 0;

  /* Dot magnetic offset */
  let dotOffsetX = 0;
  let dotOffsetY = 0;


  /* ==========================================================
     MOUSE POSITION
  ========================================================== */

  document.addEventListener('mousemove', function (event) {

    mouseX = event.clientX;
    mouseY = event.clientY;

  }, true);


  /* ==========================================================
     ANIMATION
  ========================================================== */

  function animate() {

    /* ------------------------------------------
       MAIN O FOLLOW
    ------------------------------------------ */

    currentX += (mouseX - currentX) * 0.25;
    currentY += (mouseY - currentY) * 0.25;

    cursor.style.left = currentX + 'px';
    cursor.style.top = currentY + 'px';


    /* ------------------------------------------
       VELOCITY
    ------------------------------------------ */

    velocityX = mouseX - previousMouseX;
    velocityY = mouseY - previousMouseY;

    previousMouseX += velocityX * 0.35;
    previousMouseY += velocityY * 0.35;


    const speed = Math.sqrt(
      velocityX * velocityX +
      velocityY * velocityY
    );


    /* ------------------------------------------
       DIRECTION
    ------------------------------------------ */

    const angle = Math.atan2(
      velocityY,
      velocityX
    );


    /* ------------------------------------------
       MAGNETIC STRENGTH
    ------------------------------------------ */

    const magneticStrength =
      Math.min(speed * 0.45, 10);


    const targetX =
      Math.cos(angle) * magneticStrength;

    const targetY =
      Math.sin(angle) * magneticStrength;


    /* ------------------------------------------
       RING MAGNETIC MOVEMENT
    ------------------------------------------ */

    ringOffsetX +=
      (targetX - ringOffsetX) * 0.18;

    ringOffsetY +=
      (targetY - ringOffsetY) * 0.18;


    /* ------------------------------------------
       DOT MAGNETIC MOVEMENT
    ------------------------------------------ */

    dotOffsetX +=
      (targetX - dotOffsetX) * 0.25;

    dotOffsetY +=
      (targetY - dotOffsetY) * 0.25;


    /* ------------------------------------------
       STRETCH
    ------------------------------------------ */

    const ringStretch =
      Math.min(speed * 0.025, 0.25);

    const dotStretch =
      Math.min(speed * 0.045, 0.45);


    /* Ring */

    const ringScaleX =
      1 + ringStretch;

    const ringScaleY =
      1 - ringStretch * 0.45;


    /* Dot */

    const dotScaleX =
      1 + dotStretch;

    const dotScaleY =
      1 - dotStretch * 0.35;


  /* ==========================================================
   OUTER O — MAGNETIC MOVEMENT + VELOCITY STRETCH
========================================================== */

cursor.style.transform = `
  translate(
    calc(-50% + ${ringOffsetX}px),
    calc(-50% + ${ringOffsetY}px)
  )
  rotate(${angle}rad)
  scale(${ringScaleX}, ${ringScaleY})
`;

    /* ------------------------------------------
       APPLY DOT
    ------------------------------------------ */

    dot.style.transform = `
      translate(
        calc(-50% + ${dotOffsetX}px),
        calc(-50% + ${dotOffsetY}px)
      )
      rotate(${angle}rad)
      scale(${dotScaleX}, ${dotScaleY})
    `;


    requestAnimationFrame(animate);

  }

  animate();


  /* ==========================================================
   RING INVERSION
   WHITE → BLACK OVER LIGHT AREAS
   DOT ALWAYS STAYS RED
========================================================== */

function checkLightArea() {

  const element = document.elementFromPoint(
    mouseX,
    mouseY
  );

  if (!element) return;

  const lightArea = element.closest(
    '.card__inner, .card__media, .card__content, .media, .image-with-text__media, .image-with-text img, .card-wrapper'
  );

  if (lightArea) {

    /* LIGHT AREA */

    ring.style.setProperty(
      'border-color',
      '#000000',
      'important'
    );

    dot.style.setProperty(
      'background-color',
      '#ff0000',
      'important'
    );

  } else {

    /* DARK AREA */

    ring.style.setProperty(
      'border-color',
      '#ffffff',
      'important'
    );

    dot.style.setProperty(
      'background-color',
      '#ff0000',
      'important'
    );

  }

}
  /* ==========================================================
     HOVER
  ========================================================== */

  document.addEventListener('mouseover', function (event) {

    const interactive = event.target.closest(
      'a, button, input, select, textarea, summary, [role="button"], .card-wrapper'
    );

    if (interactive) {
      cursor.classList.add('hover');
    }

  }, true);


  document.addEventListener('mouseout', function (event) {

    const interactive = event.target.closest(
      'a, button, input, select, textarea, summary, [role="button"], .card-wrapper'
    );

    if (interactive) {
      cursor.classList.remove('hover');
    }

  }, true);


  /* ==========================================================
     CLICK
  ========================================================== */

  document.addEventListener('mousedown', function () {

    cursor.classList.add('click');

  }, true);


  document.addEventListener('mouseup', function () {

    cursor.classList.remove('click');

  }, true);


  /* ==========================================================
     HIDE NATIVE CURSOR
  ========================================================== */

  document.addEventListener('mousemove', function (event) {

    if (event.target && event.target.style) {

      event.target.style.setProperty(
        'cursor',
        'none',
        'important'
      );

    }

  }, true);

});